<template>
  <div class="text-center">
  	<h2>Please wait... </h2>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { StorageFactory } from '../../../storageFactory'

export const localStore = StorageFactory(() => localStorage)

export default {
  name: 'unmudl-explore-setup',
  data: () => {
    return {
      token: '',
      cipCode: '',
      programGuideCode: '',
      type: '',
      selected: ''
    }
  },

  mounted () {
    this.loadCareerProspects()
  },

  methods: {
    ...mapActions([
      'loadUserInfo'
    ]),

    loadCareerProspects () {
      this.token = this.$route.query.refresh_token
      this.cipCode = this.$route.query.cipCode
      this.code = this.$route.query.code
      this.type = this.$route.query.type
      this.selected = this.$route.query.selected
      localStore.setItem('token', this.token)
      this.loadUserInfo(this.token).then(resp => {
        let loginTime = (new Date()).getTime()
        localStore.setItem('loginTime', loginTime)
        let routerParams = {
          cipCode: this.cipCode,
          programGuideCode: this.code,
          type: this.type,
          selected: this.selected,
          isWidget: true
        }
        return this.$router.push({name: 'programGuideCareerProspects', params: routerParams})
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/app/user/components/UnmudlExploreSetup.vue